import { PlusOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { useClientAdd } from "hook/clients/useClient";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultClientInfoSelector } from "store/user/(default)/client/default_client.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientAction = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const { loading, handleAdd } = useClientAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const clientInfo = useSelector(defaultClientInfoSelector);
  // -------------------------- FUNCTION ------------------------
  const handleAddClient = () => {
    return handleAdd(form);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!clientInfo) return null;
  return (
    <Button
      block
      type="primary"
      style={{ borderRadius: 4 }}
      icon={<PlusOutlined />}
      onClick={handleAddClient}
      loading={loading}
      disabled={loading}
    >
      Thêm Khách Hàng
    </Button>
  );
};
export default ClientAction;
